export const dishNameFieldKey = (sectionIndex, dishIndex) => `dish_${sectionIndex}_${dishIndex}`;

export const dishImageFieldKey = (sectionIndex, dishIndex) =>
  `dish_${sectionIndex}_${dishIndex}_image`;

export const dishDescriptionFieldKey = (sectionIndex, dishIndex) =>
  `dish_${sectionIndex}_${dishIndex}_description`;

export const formatDishContextLabel = (courseLabel, dishIndex) =>
  `${courseLabel} — Dish ${dishIndex + 1}`;

export const dishNameRequiredMessage = (courseLabel, dishIndex) =>
  `Dish name is required for ${formatDishContextLabel(courseLabel, dishIndex)}.`;

export const dishImageRequiredMessage = (courseLabel, dishIndex) =>
  `Dish image is required for ${formatDishContextLabel(courseLabel, dishIndex)}.`;

export const dishDescriptionRequiredMessage = (courseLabel, dishIndex) =>
  `Description is required for ${formatDishContextLabel(courseLabel, dishIndex)}.`;
